import instance from "./Request";

export const getSurveyListService = async ({ page, datobusqueda = null }) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/surveyList", {
      page,
      datobusqueda,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const duplicateSurveyService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/duplicateSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const pauseSurveyService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/pauseSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const deleteSurveyService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/deleteSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const createNewSurveyService = async (username, surveyType) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/newSurvey", {
      username,
      channel: surveyType,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const getSurveyInfoService = async (id_survey) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/infoSurvey", { id_survey });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const getSurveyStatisticsService = async ({
  start_date = null,
  end_date = null,
  phone = null,
  id_user = null,
  ...props
}) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/surveyResults", {
      start_date,
      end_date,
      phone,
      id_user,
      ...props,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const resumeSurveyService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/resumeSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const saveInitialInfoService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/aditionalInfoSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const saveFinishInfoService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/thanksYouPage", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const deleteSurveyPageService = async (id_page) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/deletePage", { id_page });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const createNewSurveyPageService = async (id_survey) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/newPage", { id_survey });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const saveSurveyDurationService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/aditionalInfoDurationSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const changeSwitchDurationService = async (id_survey) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/changeSwitchDuration", {
      id_survey,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const getQuestionTypesService = async () => {
  try {
    const request = await instance();
    const res = await request.post("/type/getTypeQuestion");
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const createNewQuestionService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/addQuestion", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const createNewQuestionOptionService = async (id_survey_question) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/addOption", { id_survey_question });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const updateSurveyQuestionService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/updateQuestion", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const deleteSurveyOptionService = async (id_question_option) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/deleteOption", {
      id_question_option,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const updateSurveyOptionService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/updateOption", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const deleteQuestionService = async (id_survey_question) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/deleteQuestion", {
      id_survey_question,
    });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const duplicateQuestionService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/duplicateQuestion", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const saveImageSurveyService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/imageSurvey", data);
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const publishSurveyService = async (id_survey) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/publishSurvey", { id_survey });
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const getSurveyExcelService = async (data) => {
  try {
    const request = await instance();
    const res = await request.post("/survey/exportResults", data, {responseType: 'blob'});
    return {
      success: true,
      data: res.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
